// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Exnug","footer":"styles_footer__1E8VB","passCodeTooltip":"styles_passCodeTooltip__RA3dP"};